<template>
    <div :class="[
        'coupon bg-color-secondary',
        { 'is-square': !isGrid }
    ]">
        <div :class="[
            { 'grid grid-center': isGrid }
        ]">
            <div class="coupon-body text-center">
                <header class="fs-44 text-bold">
                    Twój kupon rabatowy
                </header>
                <span class="fs-27">
                    wykoszystaj w dowolnej Hali MAKRO
                </span>

                <form
                    v-if="emailAddress"
                    class="coupon-body-input fs-16"
                    @submit.prevent="onSubmitSendEmailForm"
                >
                    <span class="coupon-body-input-label">Wyślij na e-mail</span>
                    <InputEmail
                        ref="inputSendEmail"
                        v-model="emailAddress"
                        :is-required="true"
                    />
                    <button class="btn btn-c--primary">
                        <i class="icon-noun_down" />
                    </button>
                </form>
                <div
                    v-else
                    class="placeholder-60"
                />

                <ButtonPrimary
                    v-if="isGrid"
                    :url="pdfDecoded.url"
                    :blob="pdfDecoded.blob"
                    :is-download="true"
                    :download-label="'kupon-rabatowy.pdf'"
                    label="Pobierz kupon (PDF)"
                    target="_blank"
                />
            </div>
            <div class="coupon-image">
                <ImageLazy
                    v-if="coupon.image"
                    :image-url="coupon.image"
                    :height="273"
                />
            </div>
            <div
                v-if="!isGrid"
                class="coupon-body text-center"
            >
                <ButtonPrimary
                    :url="pdfDecoded.url"
                    :blob="pdfDecoded.blob"
                    :is-download="true"
                    :download-label="'kupon-rabatowy.pdf'"
                    label="Pobierz kupon (PDF)"
                    target="_blank"
                />
            </div>
        </div>

        <Modal
            :is-closeable="true"
            ref="modal"
            closeLabel="Wyloguj się"
        />
    </div>
</template>

<script>
import ApiClient from '@/api/api-client'
import b64toBlob from '@/plugins/b64toBlob'
import ButtonPrimary from '@/components/button/ButtonPrimary'
import InputEmail from '@/components/form/InputEmail'
import Modal from '@/components/modal/Modal'

export default {
    components: {
        ButtonPrimary,
        InputEmail,
        Modal
    },

    props: {
        isGrid: {
            type: Boolean,
            required: false,
            default: true
        },
        coupon: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            emailAddress: null,
            isCouponSent: false
        }
    },

    computed: {
        pdfDecoded() {
            return b64toBlob(this.coupon.pdf)
        },

        endpointSendEmail() {
            if (!this.coupon.sendEmailUrl) {
                return null
            }

            const urlSplitted = this.coupon.sendEmailUrl.split('/api/')
            let endpoint = null

            if (urlSplitted.length > 1) {
                endpoint = `/${urlSplitted[1]}`
            }

            return endpoint
        }
    },

    mounted() {
        this.emailAddress = this.getCustomerEmailAddress()

        console.log(this.endpointSendEmail)
    },

    methods: {
        getCustomerEmailAddress() {
            const customerContactData = this.$store.getters['consentsResolver/customerContactData']

            return customerContactData[2] ? customerContactData[2] : ''
        },

        onSubmitSendEmailForm() {
            if (this.isCouponSent || !this.$refs.inputSendEmail.validate()) {
                return
            }

            this.$store.dispatch('siteLoader/open', 'white')

            ApiClient.post(this.endpointSendEmail, {
                email: this.emailAddress
            })
            .then(response => {
                console.log(response)

                this.isCouponSent = true

                this.$refs.modal
                    .open(`<header class="fs-32">Wysłaliśmy kupon na podany adres mailowy.</header>`, 'center-small', function() {
                        this.$store.dispatch('siteLoader/open')

                        this.$store.dispatch('apiAuth/logout')
                            .then(() => {
                                this.$store.dispatch('siteLoader/close')
                                this.$router.push({ name: 'index' })
                            })
                        })
            })
            .catch(e => {
                console.error(e.response)

                this.$refs.modal
                    .open(`<header class="fs-32">Wystąpił błąd.</header><p class="fs-22">Skontaktuj się z administratorem.</p>`, 'center-small', function() {
                        console.log('closed')
                    })
            })
            .finally(() => {
                this.$store.dispatch('siteLoader/close')
            })
        }
    }
}
</script>

<style lang="scss">
.coupon {
    padding: 4px 0 0;
    margin-top: 24px;

    &.is-square {
        padding: 48px 0 0;

        .coupon-body {
            .button-primary {
                margin-top: 25px;
                margin-bottom: 25px;
            }

            &-input {
                padding: 28px 0 18px;
            }
        }

        .coupon-image {
            text-align: center;
            padding: 12px 0 12px;
        }
    }

    .is-ie & {
        padding: 30px 0;

        &-body {
            &-input {
                [class^="input-"] {
                    position: relative;
                    top: 3px;
                }

                .btn {
                    position: relative;
                    top: 12px;
                }
            }
        }
    }

    > .grid {
        min-height: 335px;
    }

    &-body {
        &-input {
            padding: 28px 0 36px;

            [class^="input-"] {
                display: inline-block;
                max-width: 215px;
                margin: 0 8px;
            }

            .btn {
                @include size(38px);
                padding: 12px;

                > i {
                    @include transform(rotate(-90deg));
                    font-size: 15px;

                    &:before {
                        position: relative;
                        top: 4px;
                        left: 2px;
                    }
                }
            }
        }
    }

    &-image {
        padding-right: 100px;
        text-align: right;
    }

    @media (max-width: $screen-laptop) {
        > .grid {
            display: block;
            padding-bottom: 30px;
        }

        &-body {
            padding-top: 30px;
            padding-left: 20px;
            padding-right: 20px;
        }

        &-image {
            text-align: center;
            padding-right: 0;
            padding-top: 30px;
        }
    }

    @media (max-width: $screen-mobile-landscape) {
        &-body {
            &-input {
                &-label {
                    display: block;
                    padding-bottom: 10px;
                }
            }
        }
    }
}
</style>
